import { errorNotification } from '@/utils';
import {
  Mutation,
  MutationCache,
  Query,
  QueryCache,
  QueryClient,
} from '@tanstack/react-query';

const handleQueryError = (error: Error, query: Query<unknown, unknown>) => {
  if (query?.meta?.showError === true) {
    errorNotification({ error: error });
  }
};

const handleMutationError = (
  error: Error,
  variables: unknown,
  context: unknown,
  mutation: Mutation<unknown, unknown, unknown>,
) => {
  if (mutation.options?.meta?.showError === true) {
    errorNotification({ error: error });
  }
};

const handleQuerySuccess = (
  data: unknown,
  query: Query<unknown, unknown>,
) => {};

const _nonStaticQueries = (query: Query) => {
  const defaultStaleTime =
    queryClient.getQueryDefaults(query.queryKey).staleTime ?? 0;
  const staleTimes: any = query.observers
    .map(observer => observer.options.staleTime)
    .filter(staleTime => staleTime !== undefined);

  const staleTime =
    query.getObserversCount() > 0 ? Math.min(...staleTimes) : defaultStaleTime;

  return staleTime !== Number.POSITIVE_INFINITY;
};

const handleMutationSuccess = (
  data: unknown,
  variables: unknown,
  context: unknown,
  mutation: Mutation<unknown, unknown, unknown>,
) => {
  if (mutation.options.mutationKey) {
    queryClient.invalidateQueries({
      queryKey: mutation.options.mutationKey,
      // predicate: nonStaticQueries,
    });
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000,
      refetchOnWindowFocus: false,
      meta: { showError: false },
    },
    mutations: {
      meta: { showError: true },
    },
  },
  queryCache: new QueryCache({
    onError: handleQueryError,
    onSuccess: handleQuerySuccess,
  }),
  mutationCache: new MutationCache({
    onError: handleMutationError,
    onSuccess: handleMutationSuccess,
  }),
});

export { queryClient as newQueryClient };
